module.exports = __webpack_public_path__ + "static/furniture-top-brands-section-code-7d7e1d60168aadf6db7e9036b1ecc390.png";